import { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { AgGridReact } from 'ag-grid-react';
import { Button, UncontrolledTooltip, Col, Input, Row, InputGroup, InputGroupText, Badge, Label, FormText} from 'reactstrap'
import Swal from 'sweetalert2'

const TableGarantia = (props) => {

    // Hook: para poder filtrar datos de la tabla
    const gridRef = useRef();

    // Hook: Para definir un array que se usara para listar la informacion de la BD
    const [rowData, setRowData] = useState([]);

    //Hook: Definición de Filtro de Estado de Garantía
    const [selectTipoEstado, setSelectTipoEstado] = useState('habilitado')

    // Hook: Para definir un array que se usara para configurar los encabezados de columna
    const [colDefs, setColDefs] = useState([
        // { field: "idgarantia", filter: true },
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const {idgarantia, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <>                           
                        <Badge
                            id={'tooltip_' + idgarantia}
                            color='secondary'
                        >
                            <i className="nc-icon nc-alert-circle-i" />
                        </Badge>
                        
                        <UncontrolledTooltip
                            placement="top"
                            target={'tooltip_' + idgarantia}
                        >
                            Usuario Creo: { usuario_creo } 
                            <br></br>
                            Fecha Creo: { fecha_creo }
                            <br></br>
                            Usuario Modifico: { (usuario_modifico != null ? usuario_modifico : '') }
                            <br></br>
                            Fecha Modifico: { (fecha_modifico != null ? fecha_modifico : '') }
                        </UncontrolledTooltip>                     
                    </>
                    
                )
            }
        },
        { field: "nombre_cliente", headerName:"Cliente", filter: true },
        { field: "fecha_recepcion", headerName: "Fecha Recepción", filter: true },
        { field: "tipo_garantia", headerName: "Tipo Garantía", filter: true },
        { field: "descripcion_corta", headerName: "D. Corta", filter: true },
        { field: "valor_garantia", headerName: "Valor Garantía", filter: true },
        { 
            field: "estado",
            headerName: "Estado",
            minWidth: 150,
            maxWidth: 150,
            filter: 'agNumberColumnFilter',
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {
                if(params.value === 1) return 'bg-success';
                if(params.value === 0) return 'bg-warning';
            },
            cellRenderer: (params) => {
                const { value } = params

                if(value === 1) return (
                    <span><i className="fa-solid fa-circle-check"></i> HABILTIADO</span>
                );

                if(value === 0) return (
                    <span><i className="fa-solid fa-ban"></i> DESHABILITADO </span>
                );
            }
        },
        {
            headerName: "Opciones",
            minWidth: 450,
            cellRenderer: (params) => {
                const {idgarantia, estado} = params.data
                return(
                    <>
                        {/* <Button tag='p' size='sm' onClick={() => handleClickMostrarRegistro(idgarantia, 'archivos')} color='secondary' style={{ marginRight: '0.4vh' }}>
                            Archivos
                        </Button> */}
                        <Button tag='p' size='sm' onClick={() => handleClickMostrarRegistro(idgarantia, 'actualizar')} color='primary' style={ { marginRight: '0.4vh' } }>Actualizar</Button>
                        <Button tag='p' size='sm' onClick={() => handleButtonDeleteClick(idgarantia)} color='danger' style={ { marginRight: '0.4vh' } }>Eliminar</Button>
                        { (estado === 1) 
                            ? <Button tag='p' size='sm' onClick={() => handleButtonEnableDisableClick(estado, idgarantia)} color='warning' style={ { marginRight: '0.4vh' } }>Deshabilitar</Button>
                            : <Button tag='p' size='sm' onClick={() => handleButtonEnableDisableClick(estado, idgarantia)} color='success' style={ { marginRight: '0.4vh' } }>Habilitar</Button>
                        }
                    </>
                    
                )
            }
        },
    ]);
    
    // Hook: Para distribuir las columnas en toda la tabla
    const autoSizeStrategy = useMemo(() => {
        return {
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        };
    }, []);


    const externalFilterChanged = useCallback((newValue) => {
        setSelectTipoEstado(newValue);
        gridRef.current.api.onFilterChanged();
    }, []);

    const isExternalFilterPresent = useCallback(() => {
        // if ageType is not everyone, then we are filtering
        return selectTipoEstado !== 'todo';
      }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (node.data) {
            switch (selectTipoEstado) {
                case 'habilitado':
                return node.data.estado === 1;
                case 'deshabilitado':
                return node.data.estado === 0;
                default:
                return true;
            }
            }
            return true;
        },
        [selectTipoEstado]
    );


    // Hook: Para filtrar por cualquier columna de la tabla
    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
          'quickFilterText',
          document.getElementById('filtro').value
        );
    }, []);

    // Se recuperan las props del componente
    const { 
        
        // datos (listados, individuales)
        garantias,

        // hancleClicks
        handleClickMostrarRegistro,

        // Funciones
        listarGarantias,
        enableGarantia,
        disableGarantia,
        deleteGarantia,

        //Funciones para eliminar detalles de garantias
        deleteDetalleBienInmueble,
        deleteDetalleVehiculo,

    } = props

    // Para eliminar un registro seleccionado de la Tabla
    const handleButtonDeleteClick = (idgarantia) => {
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {

                await deleteDetalleBienInmueble({ idgarantia: idgarantia })
                await deleteDetalleVehiculo({ idgarantia: idgarantia })

                const res = deleteGarantia({ idgarantia: idgarantia })
                res.then(result => {
                    Swal.fire({
                        icon: 'success',
                        title: result.msg
                    })
                    listarGarantias();
                }).catch(e => {
                    console.log(e)
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un problema',
                        text: 'Comuniquese con mantenimiento'
                    })
                })
            }
        })
    }

    // Para Activar/Desactivar un registro seleccionado de la Tabla
    const handleButtonEnableDisableClick = (estado, idgarantia) => {
        if (estado === 1) {
            const res = disableGarantia({ idgarantia: idgarantia })
            res.then(result => {
                listarGarantias();
            }).catch(e => {
                console.log(e)
            })
        } else {
            const res = enableGarantia({ idgarantia: idgarantia })
            res.then(result => {
                listarGarantias();
            }).catch(e => {
                console.log(e)
            })
        }
    }

    // Se settea la información en donde corresponde
    useEffect(() => {
        
        // setColDefs([...headersTable])
        setRowData([...garantias])

        document.querySelector('#habilitado').checked = true;

    }, [garantias]);

    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            <Row>
                <Col md="12">
                    <InputGroup>
                        <InputGroupText>
                            Buscar:
                        </InputGroupText>
                        <Input 
                            id='filtro'
                            name='filtro'
                            onInput={onFilterTextBoxChanged}
                            type='text'
                        />
                    </InputGroup>
                </Col>
            </Row>

            <Row>
                <Col md="3">
                    <FormText>
                        <b>Filtro de Estado de Garantías:</b>
                        
                    </FormText>
                </Col>
                <Col md="3">
                    <Label>
                        <Input
                            type="radio"
                            name="filter"
                            id="todo"
                            onChange={() => externalFilterChanged('todo')}
                        />
                        Todo
                    </Label>
                </Col>
                <Col md="3">
                    <Label>
                        <Input
                            type="radio"
                            name="filter"
                            id="habilitado"
                            onChange={() => externalFilterChanged('habilitado')}
                        />
                        Habilitado
                    </Label>
                </Col>
                <Col md="3">
                    <Label>
                        <Input
                            type="radio"
                            name="filter"
                            id="deshabilitado"
                            onChange={() => externalFilterChanged('deshabilitado')}
                        />
                        Deshabilitado
                    </Label>
                </Col>
                <div className="border-bottom border-dark"></div>
                <div className="pt-3"></div>
                
                <Col md="12">
                    <div className="ag-theme-quartz" style={{ height: '60vh', margin: 0}}>
                        {/* The AG Grid component */}
                        <AgGridReact 
                            ref={gridRef}//PROPIEDAD PARA PERMITIR FILTRAR EN LA TABLA
                            rowData={rowData} 
                            columnDefs={colDefs} 
                            pagination={true}
                            paginationAutoPageSize={true}//PROPIEDAD PARA COLOCAR CANTIDAD DE FILAS QUE PERMITA EL TAMAÑO DE PANTALLA 
                            autoSizeStrategy={autoSizeStrategy}//PROPIEDAD PARA QUE LAS COLUMNAS LLENEN TODA LA TABLA
                            isExternalFilterPresent={isExternalFilterPresent}
                            doesExternalFilterPass={doesExternalFilterPass}
                        />
                        
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export {
    TableGarantia
}